export const packagedeals = $state({
  lAvailablePackageDeals: [], // de lijst die met de ajax call voor deze dag terug komt uit het backend
  aRecommendedPackageDealIDs: [],
  lItems: []
});

window.hmk_packagedeals = () => {
  console.log($state.snapshot(packagedeals))
}
